import { render } from "./CreateMediaspaceAdSidebar.vue?vue&type=template&id=8b730b6a&scoped=true"
import script from "./CreateMediaspaceAdSidebar.vue?vue&type=script&lang=js"
export * from "./CreateMediaspaceAdSidebar.vue?vue&type=script&lang=js"

import "./CreateMediaspaceAdSidebar.vue?vue&type=style&index=0&id=8b730b6a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b730b6a"]])

export default __exports__